import { configureStore } from '@reduxjs/toolkit'
import paysSlice from '../features/pays/paysSlice'
import payementSlice from '../features/payement/payementSlice'


export const store = configureStore({
    reducer: {
        pays: paysSlice,
        payement: payementSlice,
    },
  })
  